/**
 * Off-Canvas Navigation
 */


 (function ($) {

    var $offcanvasTrigger = $('[data-nav-trigger]'),
        $pageWrapper = $('[data-page-wrapper]'),
        pageWrapperActiveClass = 'has-active-offcanvas',
        pageWrapperActive = '.' + pageWrapperActiveClass,
        pageWrapperOverlayClass = 'c-page-wrapper__overlay',
        pageWrapperOverlay = '.' + pageWrapperOverlayClass,
        $offcanvas = $('.js-offcanvas'),
        $offcanvasLevelLink = $('.js-offcanvas__level-link'),
        $offcanvasLevel = $('.js-offcanvas__level'),
        $offcanvasLevelBack = $('.js-offcanvas__level-backlink');
        $offcanvasClose = $('.js-offcanvas__close-trigger');


    // Click off-canvas trigger
    $offcanvasTrigger.click(function() {

        // Toggle active class on trigger.
        $offcanvasTrigger.toggleClass('is-active');

        // Toggle active class on off-canvas.
        $offcanvas.toggleClass('is-active');

        // Toggle page wrapper active class.
        $pageWrapper.toggleClass(pageWrapperActiveClass);

        // Remove active classes from all elements in off-canvas.
        $offcanvas.find('.is-active').removeClass('is-active');

        // Remove page wrapper overlay element.
        $(pageWrapperOverlay).remove();

        // Add page wrapper overlay element.
        // This element prevents unwanted actions when clicking
        // on page to close off-canvas
        $pageWrapper.filter(pageWrapperActive)
          .append('<div class="' + pageWrapperOverlayClass + '"></div>');

        return false;

    });


    // Click page-wrapper overlay
    $pageWrapper.on('click', pageWrapperOverlay, function(){

        // Remove active class from trigger.
        $offcanvasTrigger.removeClass('is-active');

        // Remove active class from off-canvas.
        $offcanvas.removeClass('is-active');

        // Remove page wrapper active class.
        $pageWrapper.removeClass(pageWrapperActiveClass);

        // Remove page-wrapper overlay.
        $(this).remove();

        return false;

    });



    $offcanvasLevelLink.click(function() {

        var $this = $(this);

        $this
            // toggle off-canvas level active class
            .next($offcanvasLevel)
            .css('position', 'fixed')
            .toggleClass('is-active')

            // scroll to top
            .parents('body')
            .animate({
              scrollTop: 0
            }, {
              complete: function() {
                $offcanvasLevel.css('position', 'absolute');
              }
            });

        return false;

    });

    $offcanvasLevelBack.click(function() {

        $(this).closest('.c-offcanvas__level').removeClass('is-active');
        return false;

    });

    $offcanvasClose.click(function() {

        $(this).closest('.c-offcanvas__close').removeClass('is-active');
        $('[data-page-wrapper]').removeClass('has-active-left-offcanvas').removeAttr('style');
        return false;

    });



 })(jQuery);


